<template>
    <article class="article-preview u-reset article-preview--link">
        <div class="article-preview--row ">
            <div class="article-preview--content article-preview--col">
                <div>
                    <div class="u-reset article-preview--title">
                        <slot name="title">{{ title }}</slot>
                    </div>
                    <p class="u-reset article-preview--description">
                        <slot name="description">{{ description }}</slot>
                    </p>
                </div>
                <span class="article-preview--date">
                    <slot name="date">{{ date }}</slot>
                </span>
            </div>
            <div class="article-preview--visual article-preview--col">
                <dyn-aspect-ratio-image :image-url="image.urls.default[0]"/>
            </div>
        </div>
    </article>
</template>

<script>
    import PictureElement from 'framework/global-components/dyn/picture-element/picture-element';

    export default {
        components: { PictureElement },
        props: {
            title: {
                type: String,
                default: null,
            },

            description: {
                type: String,
                default: null,
            },

            date: {
                type: String,
                default: null,
            },

            /** @type {ISvgImageSet} */
            image: {
                type: Object,
                default: null,
            },

            /** @type {ILink} */
            link: {
                type: Object,
                default: null,
            },

            path: {
                type: String,
                default: null,
            },
        },

        computed: {
            articlePath() {
                if (this.link) {
                    return this.link.path;
                }
                return this.path;
            },
        },
    };
</script>
